import { Box } from '../../ui/Box';

export const SidebarSeparator = () => {
    return (
        <Box paddingX={4} paddingY={4}>
            <Box height="1px" backgroundColor="border.muted" />
        </Box>
    );
};
